package com.devi3east.bashbuddy.di

import com.devi3east.bashbuddy.auth.capability.AuthCapability
import com.devi3east.bashbuddy.auth.capability.WebAuthCapability
import com.devi3east.bashbuddy.cart.storage.CartStorage
import com.devi3east.bashbuddy.cart.storage.WebCartStorage
import com.devi3east.bashbuddy.features.ticketing.WebTicketingCapability
import com.devi3east.bashbuddy.features.ticketing.TicketingCapability

actual fun ticketingCapability(): TicketingCapability = WebTicketingCapability()
actual fun authCapability(): AuthCapability = WebAuthCapability()
actual fun cartStorage(): CartStorage = WebCartStorage()